/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Export_Aborted_ToastInputs */



/**
* | output |
* | --- |
* | "Subtitle export was aborted" |
*
* @param {Iconik_Publish_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_export_aborted_toast = /** @type {((inputs?: Iconik_Publish_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Export des sous-titres annule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Export der Untertitel wurde abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'esportazione dei sottotitoli è stata interrotta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт субтитров был прерван.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se canceló la exportación de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导出已中止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のエクスポートが中止されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निर्यात रद्द कर दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A exportação de legendas foi cancelada.")
	return /** @type {LocalizedString} */ ("Subtitle export was aborted")
});